export default __webpack_public_path__ + "static/media/hat2 4.38d620a4.svg";